import { render, staticRenderFns } from "./TogglePills.vue?vue&type=template&id=3554c196&scoped=true&"
import script from "./TogglePills.vue?vue&type=script&lang=js&"
export * from "./TogglePills.vue?vue&type=script&lang=js&"
import style0 from "./TogglePills.vue?vue&type=style&index=0&id=3554c196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554c196",
  null
  
)

export default component.exports